import { render, staticRenderFns } from "./SelectShelfPeriodPriceComponent.vue?vue&type=template&id=21c3263c&scoped=true"
import script from "./SelectShelfPeriodPriceComponent.vue?vue&type=script&lang=js"
export * from "./SelectShelfPeriodPriceComponent.vue?vue&type=script&lang=js"
import style0 from "./SelectShelfPeriodPriceComponent.vue?vue&type=style&index=0&id=21c3263c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21c3263c",
  null
  
)

export default component.exports